<template>
	<div>
		<ExpensesTabs
			:tab="'Manager Review'"
			@tab="onTabChange($event)"			
		/>
		<div class="pb-2">
			<div class="head-title px-6 d-print-none">
				<ApprovalButtonMulti
					:control="control"
					:itemNumberApprove="itemNumberApprove"
					:itemNumberMoreInfo="itemNumberMoreInfo"
					:itemNumberForward="itemNumberForward"
					:itemNumberPrint="itemNumberPrint"
					:itemNumberDelete="itemNumberDelete"
					:approveLoading="approve_loading"
					:rejectLoading="visible_moreinfo"
					:forwardLoading="visible_forward"
					:deleteLoading="visible_delete"
					:printLoading="print_dialog"
					@approve="onApprove()"
					@more-info="onMoreInfoDialog()"
					@forward="onForwardDialog()"
					@delte="onDelteDialog()"
					@print="onPrint()" />
				<ApprovalView 
					:typeSelected="type"
					:viewSelected="view"
					:statuses="approval_statuses"
					:customise_view="customise_view" 
					@status="onChangeStatus($event)"
					@column="onChangeColumn($event)"
				/>
			</div>
			<v-alert class="mx-5 mt-3" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<ProgressGetDataLinear v-if="loading" class="px-5"/>
			<ApprovalTable 
				class="ma-6" 
				v-if="!loading"
				:header="select_column"
				:items="filterResults" 
				:color="color" 
				:currencies="currencies"
				:statuses="approval_statuses.map(status => {return status.text})"
				:titleText="$vuetify.breakpoint.xs ? 'Claims':'Claims for Approval'"
				@row-item="onRowClick($event)"
				@button-visible="onButtonVisible($event)" />
			<ApprovalDialog 
				v-if="visible_moreinfo"
				key="moreinfo"
				:visible="visible_moreinfo" 
				:color="color"
				:title_text="`Describe the information required for this claim...`"
				:suppliers="select_claims.map(c => { return c.supplier })"
				@cancel="onCancel()"
				@ok="onMoreInfo($event)"
			/>
			<ApprovalDialog 
				v-if="visible_forward"
				key="forward"
				:visible="visible_forward" 
				:color="color"
				:title_text="`Forward claim`"
				:isForward="true"
				:userID="user_abid"
				:confirm_button="`Submit`"
				@cancel="onCancel()"
				@submit="onForward($event)"
			/>
			<DeleteConfirmDialog
				v-if="visible_delete"
				:visible="visible_delete"
				:title="`You are about to delete claim(s)`"
				:content="`This action cannot be undone. Are you sure?`"
				:okText="`Delete`"
				@cancel="visible_delete = false"
				@ok="onDelete()"
			/>
			<DialogNotice
				v-if="visible_notice" 
				:visible="visible_notice" 
				:text="notice_text"
			/>
			<PrintClaims 
				v-if="print_visible" 
				id="print"
				style="display: none"
				:printClaims="print_claims" />
			<DialogProgress 
				:visible="print_dialog" 
				:color="color"
			/>
		</div>
	</div>
</template>
<script>
import ApprovalView from "@/views/expenses/approvals/approval_view.vue";
import ApprovalButtonMulti from "@/views/expenses/approvals/approval_button_multi.vue";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import ApprovalTable from "@/views/expenses/approvals/approval_table.vue";
import ApprovalDialog from "@/views/expenses/approvals/approval_dialog.vue";
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";

import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import PrintClaims from '@/components/expenses/print_claims';
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";

import config from "@/config.js";
import moment from 'moment';
import { metaReceiptMixin } from "@/mixins/expenses/metaReceiptMixin";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;

const CLAIM_STATUSES = config.claim_statuses;

const ACCEPTED_SWITCH = {
	key: 'Accepted',
	value: 'Approved'
};

const APPROVAL_STATUS = [
	{ text: 'Submitted', value: 1 }, 
	{ text: 'Approved', value: 2 },
	{ text: 'Rejected', value: 3 },
];

// Edit expense claim privilege
const EECP = 'Secapa';

export default {
	name: 'ListApproval',
	mixins: [metaReceiptMixin],
	data() {
		this.approval_statuses = APPROVAL_STATUS;
		this.customise_view = config.approval_head.filter(head => {return head.showable && head.value !== 'select'});
		this.remark_date_flag = config.remark_date_flag;

		return {
			user_id: 0,
			control: false,
			loading: false,
			error_msg: '',
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
			select_column: config.approval_head,

			type: APPROVAL_STATUS.filter(s => { return s.value === CLAIM_STATUSES.pending.value }),
			type_save: APPROVAL_STATUS.filter(s => { return s.value === CLAIM_STATUSES.pending.value }),
			view: [],
			view_save: [],

			approval_list: [],
			pre_update_claims: [],
			visible_moreinfo: false,
			visible_forward: false,
			visible_notice: false,
			visible_delete: false,
			select_claims: [],
			notice_text: [],
			tid: null,
			all_completed: [],

			print_claims: [],
			image_arr: [],
			image_res_arr: [],
			print_dialog: false,
			print_visible: false,

			itemNumberApprove: 0,
			itemNumberMoreInfo: 0,
			itemNumberForward: 0,
			itemNumberPrint: 0,
			itemNumberDelete: 0,

			approve_loading: false
		}
	},
	components: {
		ApprovalView,
		ApprovalButtonMulti,
		ApprovalTable,
		ProgressGetDataLinear,
		ApprovalDialog,
		DialogNotice,
		DialogProgress,
		PrintClaims,
		ExpensesTabs,
		DeleteConfirmDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		this.load_meta_data();
		this.update_breadcrumb();

		if (!this.$store.state.user) {
			await this.getUserId();
		} else {
			this.user_id = this.$store.state.user.id;
		}

		await this.getSettings();

		this.init_approvals(this.type_save.map(s => { return s.value }));
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		user_abid_name() {
			let name = '';
			const user = this.$store.state.user;
			if (user) {
				name = user.addressbook.display_name;
			}
			return name;
		},
		filterResults() {
			const filterRes = [];
			this.approval_list.forEach(approval => {
				const obj = {};	
				const select_column_tmp = config.approval_head;

				select_column_tmp.forEach(item => {
					if (item.showable) {
						obj[item.value] = approval[item.value];
					}
				});

				obj['id']	= approval.id;
				obj['select'] = approval.select ? approval.select : false;

				filterRes.push(obj);
			});
			return filterRes;
		},
		isFinanceUser() {
			let isFinanceUserTmp = false;
			const privileges = this.$store.state.privileges;
			if (privileges.length !== 0 && privileges.includes(EECP)) {
				isFinanceUserTmp = true;
			}
			return isFinanceUserTmp;
		}
	},
	methods: {
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: 'Manager Review',
				to: '/expenses/manager_review'
			});
		},
		async getUserId() {
			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onTabChange(current_tab) {
			this.$router.push({ name: current_tab });
		},
		async getSettings() {
			this.loading = true;
			const usid = this.user_id;
			const winname_tmp = this.$route.name.split(' ');
			const winname = config.win_name[`${winname_tmp[0]}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const type_tmp = windata.type;
								const view_tmp = windata.options;

								this.type = APPROVAL_STATUS.filter(c => { return type_tmp.includes(c.value) });
								this.view = config.approval_head.filter(head => {return head.showable && view_tmp.includes(head.value) });

								this.type_save = this.type;
								this.view_save = this.view;
							}
						} else {
							this.view = config.approval_head.filter(head => {return head.showable && head.value !== 'select'});
							this.view_save = config.approval_head.filter(head => {return head.showable && head.value !== 'select'});
						}

						this.initTableHead();

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname_tmp = this.$route.name.split(' ');
			const winname = config.win_name[`${winname_tmp[0]}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		initTableHead() {
			const head_seleced = config.approval_head.filter(head => { return head.showable && head.value === 'select'});
			
			const view = this.view.map(v => { return v.value });
			const head_other = config.approval_head.filter(head => { return view.includes(head.value) });

			this.select_column = [...head_seleced, ...head_other];
		},
		init_approvals(statusses) {
			if (this.user_abid !== 0) {
				this.loading = true;
				const params = [];
				
				if (statusses.length > 0) {
					params.push("statusses=" + statusses);
				}
				const approval_by = `${this.user_abid}`;
				if (approval_by.length > 0) {
					params.push("approval_by=" + approval_by);
				}

				let url = "/api/expenses/claims";
				if (params.length > 0) {
					url+= "?" + params.join('&');
				}
			
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, data, reason } = val.data;
						if (status === 'OK') {
							data.forEach(d => {
								if (d.status === ACCEPTED_SWITCH.key) {
									d.status = ACCEPTED_SWITCH.value;
								}
							});

							const approved_arr = data.filter(d => {return d.status === CLAIM_STATUSES.approved.text});
							approved_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date1 - date2;
							});

							const other_arr = data.filter(d => {return d.status !== CLAIM_STATUSES.approved.text});
							other_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date1 - date2;
							});

							other_arr.forEach(o => {
								if (o.status == CLAIM_STATUSES.rejected.text) {
									const remark_split_arr = o.remark ? o.remark.split(this.remark_date_flag) : [null, null];
									const remark = remark_split_arr[0];
									const remark_date = remark_split_arr[1];
									o['remark'] = remark ? remark : '';
									o['remark_date'] = remark_date ? remark_date : null;
								}
							});

							this.approval_list = [];
							this.approval_list.push(...other_arr);
							this.approval_list.push(...approved_arr);

							this.loading = false;
							this.control = false;
							this.itemNumberApprove = 0;
							this.itemNumberMoreInfo = 0;
							this.itemNumberForward = 0;
							this.itemNumberPrint = 0;
						} else {
							this.error_msg = reason;
							this.loading = false;
						}
					})
					.catch(msg => {
						this.error_msg = msg;
						this.loading = false;
					});
			};
		},
		onChangeStatus(status) {
			this.type = status;
			this.type_save = status;
			this.init_approvals(this.type_save.map(s => { return s.value }));

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onChangeColumn(column) {
			const head_seleced = config.approval_head.filter(head => { return head.showable && head.value === 'select'});
			const head_other = config.approval_head.filter(head => { return column.includes(head.value) });
			this.select_column = [...head_seleced, ...head_other];

			this.view = config.approval_head.filter(head => { return column.includes(head.value) });
			this.view_save = config.approval_head.filter(head => { return column.includes(head.value) });

			const win_setup_str = this._setWinSetup();
			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onButtonVisible(claim_arr) {
			const arr_tmp = claim_arr.map(val => { return val.select});
			this.control = arr_tmp.some(val => {return val});

			const itemNumberApprove_tmp = claim_arr.filter(val => { return val.select && val.status ===  CLAIM_STATUSES.pending.text});
			this.itemNumberApprove = itemNumberApprove_tmp.length;

			const itemNumberMoreInfo_tmp = claim_arr.filter(val => { return val.select && val.status === CLAIM_STATUSES.pending.text });
			this.itemNumberMoreInfo = itemNumberMoreInfo_tmp.length;

			const itemNumberForward_tmp = claim_arr.filter(val => {
				return val.select && val.status === CLAIM_STATUSES.pending.text
			});
			this.itemNumberForward = itemNumberForward_tmp.length;

			const itemNumberPrint_tmp = claim_arr.filter(val => { return val.select });
			this.itemNumberPrint = itemNumberPrint_tmp.length;

			const itemNumberDelete_tmp = claim_arr.filter(val => {
				if (this.isFinanceUser) {
					return val.select;
				} else {
					return val.select && val.supplier.id === this.user_abid;
				}
			});
			this.itemNumberDelete = itemNumberDelete_tmp.length;
		},
		onRowClick(item) {
			this.$router.push({ name: 'Approve Claim', params: { id: item.id } });
		},
		async onApprove() {
			if (this.approve_loading) return;

			this.approve_loading = true;
			this.select_claims = this.filterResults.filter(res => { return res.select === true });
			
			// for right status claims
			const update_claims = this.select_claims.filter(c => { return c.status === CLAIM_STATUSES.pending.text });
			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];
				await this._laod_claim(element.id, true);	
			}

			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const details = [];
				element.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					})
				});

				const update_obj = {
					supplier_id: element.supplier.id,
					date: element.date,
					desc: element.description,
					currency_id: element.currency.id,
					approval_by: element.approval_by.id,
					status: CLAIM_STATUSES.approved.value,
					remark: '',
					period_id: element.period.id,
					details: details
				};
				await this._update_claim(element.id, update_obj);
			}
			this.approve_loading = false;

			// for results
			if (this.all_completed.length === this.pre_update_claims.length && this.pre_update_claims.length !== 0) {
				if (update_claims.length === 1) {
					this.notice_text.push('The claim has been approved.');
				} 
				if(update_claims.length > 1) {
					this.notice_text.push(`${update_claims.length} claims have been approved.`);
				}

				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);

				this.onCancel();
				this.init_approvals(this.type_save.map(s => { return s.value }));
			} 
		},
		async onMoreInfoDialog() {
			if (this.visible_moreinfo) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true;});
			const update_claims = this.select_claims.filter(c => { return c.status === CLAIM_STATUSES.pending.text });
			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];
				await this._laod_claim(element.id, true);	
			}
			this.visible_moreinfo = true;
		},
		async onMoreInfo(reason) {
			const reason_with_date = `${reason}${config.remark_date_flag}${moment().format('YYYY-MM-DD')}`;
			this._unUpdateText('Rejected');

			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const details = [];
				element.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					});
				});

				const update_obj = {
					supplier_id: element.supplier.id,
					date: element.date,
					desc: element.description,
					currency_id: element.currency.id,
					approval_by: element.approval_by.id,
					status: CLAIM_STATUSES.rejected.value,
					remark: reason_with_date,
					period_id: element.period.id,
					details: details
				};
				await this._update_claim(element.id, update_obj);
			}
			
			this.onCancel();
			this.init_approvals(this.type_save.map(s => { return s.value }));
		},
		async onForwardDialog() {
			if (this.visible_forward) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true;});
			const update_claims = this.select_claims.filter(c => { return c.status === CLAIM_STATUSES.pending.text });
			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];
				await this._laod_claim(element.id, true);	
			}
			this.visible_forward = true;
		},
		async onForward(event) {
			this._unUpdateText('Rejected');

			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const details = [];
				element.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					})
				});

				const update_obj = {
					supplier_id: element.supplier.id,
					date: element.date,
					desc: element.description,
					currency_id: element.currency.id,
					approval_by: event.approval_by.id,
					status: element.status,
					remark: event.reason,
					period_id: element.period.id,
					send_email: true,
					details: details
				};
				await this._update_claim(element.id, update_obj);
			}
			this.onCancel();
			this.init_approvals(this.type_save.map(s => { return s.value }));
		},
		onDelteDialog() {
			if (this.visible_delete) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true });
			const delete_claims = this.select_claims.filter(c => {
				if (this.isFinanceUser) {
					return c;
				} else {
					return c.supplier.id === this.user_abid;
				}
			});

			this.pre_update_claims = delete_claims;
			this.visible_delete = true;
		},
		async onDelete() {
			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				await this._delete_claim(element.id);
			}

			this.onCancel();
			this.init_approvals(this.type_save.map(s => { return s.value }));
		},
		onCancel() {
			this.visible_forward = false;
			this.visible_moreinfo = false;
			this.visible_delete = false;
			this.select_claims = [];
			this.pre_update_claims = [];
			this.all_completed = [];
		},
		async onPrint() {
			if (this.print_dialog) return;

			this.print_dialog = true;
			this.print_claims = [];

			const image_blob_arr = [];
			const selected_claims = this.filterResults.filter(f => { return f.select === true });

			for (let index = 0; index < selected_claims.length; index++) {
				const selected_claim = selected_claims[index];
				const url = "/api/expenses/claims/" + selected_claim.id;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then(val => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							data.details.forEach(d => {
								if (d.receipt.image_type.length !== 0) {
									const obj_tmp = {
										id: data.id,
										receipt: d.receipt 
									};
									image_blob_arr.push(obj_tmp);
								}
							});

							const obj = {
								id: selected_claim.id,
								number: selected_claim.number,
								desc: selected_claim.desc,
								submitted_date: selected_claim.submitted_date,
								value: selected_claim.value,
								currency: selected_claim.currency.symbol,
								approval_by: data.approval_by.display_name,
								employee: data.supplier.display_name,
								supplier: data.supplier.display_name,
								claim_date: selected_claim.date,
								details: data.details,
							};
							this.print_claims.push(obj);

						} else {
							this.error_msg = reason;
						}
					})
					.catch(e => {
						this.error_msg = e.message;
					});
			}

			this.getImageList(image_blob_arr);
		},
		async getImageList(image_blob_arr) {
			if (image_blob_arr.length === 0) {
				this.print_claims.forEach(print_claim => {
					print_claim['image_arr'] = [];
				});
				this.setPrintItem();
			}

			if (image_blob_arr.length !== 0) {
				for (let index = 0; index < image_blob_arr.length; index++) {
					const image_obj = image_blob_arr[index];
					const url = `/api/expenses/receipts/${image_obj.receipt.id}/image`;
					await axios
						.get(url, {
							headers: {
								"Authorization": "Bearer " + this.$store.state.token,
								"Accept": "application/json"
							},
							responseType: 'blob',
						})
						.then((val) => {
							const { status, data } = val;
							if (status === 200) {
								if (image_obj.receipt.image_type === 'application/pdf') {
									const reader = new FileReader();
									reader.readAsDataURL(data); 
									reader.onload = readerEvent =>  {
										const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
										loadingTask.promise.then(pdf => {
											const preview_url = [];
											let page_total = pdf.numPages;

											for (let index = 0; index < pdf.numPages; index++) {
												pdf.getPage(index + 1).then(page => {
													const scale = SCALE;
													const viewport = page.getViewport({scale: scale});

													const canvas = document.createElement('canvas');
													const context = canvas.getContext('2d');
													canvas.width = viewport.width;
													canvas.height = viewport.height;

													const renderContext = {
														canvasContext: context,
														viewport: viewport
													};

													const renderTask = page.render(renderContext);
													renderTask.promise.then(() => {
														canvas.toBlob(blob => {
															const preview_item_url = URL.createObjectURL(blob);
															preview_url.push(preview_item_url);
															page_total -= 1;

															if (page_total === PAGE_INIT) {
																const dimension = this.getDimension(viewport.width, viewport.height);
																const obj = {
																	id: image_obj.id,
																	width: dimension.width,
																	height: dimension.height,
																	image: preview_url
																};
																this.image_arr.push(obj);

																if (image_blob_arr.length === this.image_arr.length) {
																	this.print_claims.forEach(print_claim => {
																		print_claim['image_arr'] = this.image_arr;
																	});
																	this.setPrintItem();
																}
															}
														});									
													});
												});
											}
										});
									};
								} else {
									const my_image = new Image();
									const preview_item_url = URL.createObjectURL(data);
									my_image.src = preview_item_url;
									my_image.onload = () => {
										const dimension = this.getDimension(my_image.width, my_image.height);
										const obj = {
											id: image_obj.id,
											width: dimension.width,
											height: dimension.height,
											image: preview_item_url
										};
										this.image_arr.push(obj);

										if (image_blob_arr.length === this.image_arr.length) {
											this.print_claims.forEach(print_claim => {
												print_claim['image_arr'] = this.image_arr;
											});
											this.setPrintItem();
										}
									}

								}
							}
						})
						.catch((e) => {
							this.$emit('error-msg', e.message);
						});
				}
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem() {
			this.print_dialog = false;
			this.print_visible = true;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.print_visible = false;
							this.image_arr = [];
							this.init_approvals(this.type_save.map(s => { return s.value }));
						}
					}
				}
			},20);
		},
		async _laod_claim(id, forUpdate) {
			if (!forUpdate) {
				this.loading = true;
			}
			
			const url = "/api/expenses/claims/" + id;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " +this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (forUpdate) {
							this.pre_update_claims.push(data);
						} 
						
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async _update_claim(id, update_obj) {
			const url = "/api/expenses/claims/" + id;
			await axios
				.put(url, update_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.all_completed.push(true);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		async _delete_claim(id) {
			const url = `/api/expenses/claims/${id}`;
			await axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.pre_update_claims = this.pre_update_claims.filter(p => { return p.id !== id });

						if (this.pre_update_claims.length === 0) {
							this.notice_text.push(`Claim(s) were successfully deleted.`);
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_unUpdateText(text) {
			const text0 = `We can't do this as the claim has already been marked '${text}'.`;
			this.notice_text.push(text0);

			const un_update_claims = this.select_claims.filter(c => { return c.status !== CLAIM_STATUSES.pending.text });
			if (un_update_claims.length === 1) {
				const text1 = `The rejected claim has been sent to (${un_update_claims[0].supplier.display_name}).`;
				this.notice_text.push(text1);
			} 

			if (un_update_claims.length >1) {
				const name_arr = un_update_claims.map(claim => { return claim.supplier.display_name });
				const name_arr_unique =  Array.from(new Set(name_arr));

				let temp_str = '';

				name_arr_unique.forEach((name, index) => {
					if ((index + 1) !== name_arr_unique.length) {
						temp_str += name + ', ';
					} else {
						temp_str += name;
					}
				});
				const text1 = `The rejected claims have been sent to (${temp_str}).`;
				this.notice_text.push(text1);
			}

			if (un_update_claims.length !== 0) {
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);
			}
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_add(num1, num2) {
			const num1Digits = (num1.split('.')[1] || '').length;
			const num2Digits = (num2.split('.')[1] || '').length;
			const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
			const result = (num1 * baseNum + num2 * baseNum) / baseNum;
			return result.toString();
		},
		_setWinSetup() {
			const type_tmp = this.type_save.map(t => { return t.value });
			const view_tmp = this.view_save.map(t => { return t.value });

			const win_setup_obj = {
				type: type_tmp,
				options: view_tmp,
			};

			const win_setup_str = JSON.stringify(win_setup_obj);
			return win_setup_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.head-title {
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
}
</style>